export function buildAvatarTypeErrorMessage() {
  return '请选择图片文件';
}

export function buildAvatarSizeErrorMessage() {
  return '图片大小不能超过 2MB';
}

export function buildProfileUpdateMessage(result) {
  if (result?.success) {
    return { type: 'success', text: '资料更新成功' };
  }
  return { type: 'error', text: result?.error || '资料更新失败' };
}

export function resolvePasswordPrecheckError({
  newPassword,
  confirmPassword,
  username,
  validatePasswordPolicyFn,
}) {
  if (newPassword !== confirmPassword) return '两次输入的密码不一致';
  return validatePasswordPolicyFn(newPassword, username);
}

export function buildPasswordChangeMessage(result) {
  if (result?.success) {
    return { type: 'success', text: '密码修改成功' };
  }
  return { type: 'error', text: result?.error || '密码修改失败' };
}

export function buildPasswordResetFields() {
  return {
    oldPassword: '',
    newPassword: '',
    confirmPassword: '',
  };
}
